import React from 'react';
import { Box, Text, Heading, ButtonPrimary } from '@primer/components'
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';

import Masonry from '../../../components/BeforeAfter/Masonry'
import * as constants from '../../../constants'
import { useCategory } from '../../../hooks/useCorpus'


export default function(props) {
  return (
    <Box className="position-relative pt-md-0 pt-4 pl-4 pr-4 pb-md-6">
      <Box id="security">
        <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0" id="features">
          <Box className="col-md-12  pb-4">
            <Heading>Enhance your security</Heading>
            <Text className="f3">Protect your business and users against common vulnerabilities including <Link to="/features/django/compare-django-release-notes/3.0.0/3.1.6">missing Django fixes</Link>, XSS, Cross Site Request Forgery, clickjacking, session cookie hijacking, </Text>
            <Link className="f3" to="/advice/security">and more</Link>.
          </Box>
        </Box>
        <Box className="container-lg" style={{maxWidth:1130}}>
          <Masonry corpus={useCategory(constants.CATEGORY_SECURITY)} showLabels={false} />
        </Box>
      </Box>

      <Box id="performance">
        <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0 mt-4">
          <Box className="col-md-12 pb-4">
            <Heading>Improve your website's speed</Heading>
            <Text className="f3">Over half of Django websites are slowed by unoptimized code. Website speed has a direct impact on the success of your organization. </Text>
            <Text className="f3">Protect against unoptimized code that at best lose you customers and at worse bring your website down. </Text>
            <Link className="f3" to="/advice/performance">Read more</Link>.
          </Box>
        </Box>
        <Box className="container-lg" style={{maxWidth:1130}}>
          <Masonry corpus={useCategory(constants.CATEGORY_PERFORMANCE)} showLabels={false} />
        </Box>
      </Box>

      <Box id="maintainability">
        <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0">
          <Box className="col-md-12  pb-4">
            <Heading>Ensure maintainability best practices</Heading>    
            <Text className="f3">Automatically find and fix over 40 issues, so your team can focus on adding value. Reduce costs by preventing tech debt including hidden 404s, migrations blocking production rollback, hard-coded urls, </Text>
            <Link className="f3" to="/advice/maintainability">and more</Link>.
          </Box>
        </Box>
        <Box className="container-lg" style={{maxWidth:1130}}>
          <Masonry corpus={useCategory(constants.CATEGORY_MAINTAINABILITY)} />
        </Box>
      </Box>
    </Box>
  );
}
